import { Component, OnInit, OnDestroy, PLATFORM_ID, Inject, Input } from '@angular/core';
import { ConfLobControlService } from '../../Services/conf-lob-service/conf-lob-control.service';
import { lastValueFrom, Observable, Subscription, take } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { getAllState } from '../../../../configurator-app/conf-store/reducer';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../../environments/environment';
import { isPlatformBrowser } from '@angular/common';
import { RootService } from '../../../../shared/services/root.service'; //for osp team

interface VcDataType {
  "vc": string;
  "prod_desc": string;
  "total_sales": number;
  "usage_count": number;
  "most_viewed": boolean;
}

@Component({
  selector: 'app-conf-predictive-vc',
  templateUrl: './conf-predictive-vc.component.html',
  styleUrls: ['./conf-predictive-vc.component.scss']
})
export class ConfPredictiveVcComponent implements OnInit, OnDestroy {
  confAWSUrlStr: any = environment.confAWSurl;
  listData$: Observable<Array<VcDataType>>;
  listDataSubscription: Subscription = new Subscription
  stepArrSubscription: Subscription = new Subscription

  storeSubscription: Subscription = new Subscription
  compVisibility: boolean = true
  postSubscribe: any = new Subscription;
  userData: any = {}
  environmentUrl: string = ""

  @Input() lob: any

  public predictiveVCfeatureArr: Array<VcDataType> = [];

  constructor(
    private secureService: RootService,
    private _dataLobService: ConfLobControlService,
    private store: Store, private router: Router,
    private cookie_service: CookieService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.listData$ = this._dataLobService.sharePredData
  }

  async ngOnInit(): Promise<void> {
    this.userData = this.secureService.getUserData(); //for osp team
    this.environmentUrl = environment.baseUrl
    this.listDataSubscription = this.listData$.subscribe((data: VcDataType[]) => {
      this.predictiveVCfeatureArr = data
      if (data.length === 0) {
        this.getPredictiveTabClose(false)
      } else {
        this.getPredictiveTabOpen(true)
      }
    })
    this._dataLobService.sharedPreCompState.subscribe((data: boolean) => this.compVisibility = data)
  }

  ngOnDestroy(): void {
    this.listDataSubscription.unsubscribe()
    this._dataLobService.updatePredcompState(true)
    this.stepArrSubscription.unsubscribe()
  }

  async navigateToSummary(vc_no: string) {
    if (isPlatformBrowser(this.platformId)) {
      window.open(environment.baseUrl + `/fleetverse-predictive/${this.lob}/${vc_no}`, '_blank')
    }
    await this._dataLobService.savePredconfSelection(vc_no)
  }


  //Added by DK
  public setPredictiveTabClose: any = true;
  getPredictiveTabClose(value: any) {
    this.setPredictiveTabClose = value
  }
  getPredictiveTabOpen(value: any) {
    this.setPredictiveTabClose = value
  }
}